import React from 'react';

export const IconCss: React.FC<React.SVGAttributes<SVGElement>> = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 362.7 512">
    <path
      fill="#264de4"
      d="M362.7 100.6l-33 370.2L181 512l-148-41.1L0 100.6z"
    />
    <path fill="#2965f1" d="M301.4 447.2L329.6 131H181.4v349.6z" />
    <path
      fill="#ebebeb"
      d="M75.7 268.2l4 45.4h101.7v-45.4zM181.4 176.3H67.5l4.1 45.4h109.8zM181.4 433.4v-47.2h-.2l-50.6-13.6-3.2-36.3H81.8l6.3 71.3 93 25.9z"
    />
    <path
      fill="#ffffff"
      d="M85.4 0h55v23h-32v23h32v23h-55zM151.4 0h55v20h-32v4h32v46h-55V49h32v-4h-32zM217.4 0h55v20h-32v4h32v46h-55V49h32v-4h-32z"
    />
    <path
      fill="#fff"
      d="M237.1 313.6l-5.2 59-50.7 13.6v47.2l93.1-25.8.7-7.6 10.7-119.6 1-12.2 8.3-91.9H181.2v45.4h64l-4.1 46.5h-59.9v45.4z"
    />
  </svg>
);
